import httpClient from "../http/http-client";
import { IRole } from './users-teams.model';

export default class UsersTeamService {
  http;

  constructor() {
    this.http = httpClient
  }

  async getAllRoles(): Promise<IRole[]> {
    return this.http.get('user/user-role')
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      })
  }
}